import { Component, Input } from '@angular/core';

@Component({
  selector: 'jhi-bary-link',
  standalone: true,
  templateUrl: './bary-link.component.html',
  styleUrls: ['./bary-link.component.scss'],
})
export class BaryLinkComponent {
  @Input() class?: string;
  @Input() label!: string;
  @Input() href?: string;
}
